import { render, staticRenderFns } from "./TheSecurityPermissions.vue?vue&type=template&id=276ddee6&"
import script from "./TheSecurityPermissions.vue?vue&type=script&lang=js&"
export * from "./TheSecurityPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports